<template>
  <b-modal :active="show" @close="toggle" class="modal" has-modal-card :can-cancel="false">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Account Information</p>
      </header>

      <div class="modal-card-body">
        <carrier-info v-model="details"
                      :show-basic-info="$attrs['show-basic-info']"
                      :show-equipment-info="$attrs['show-equipment-info']"
                      :show-insurance-info="$attrs['show-insurance-info']"
                      :show-documents-info="$attrs['show-documents-info']"
                      @isComplete="onIsComplete"></carrier-info>
      </div>

      <footer class="columns modal-card-foot">
        <div class="column">
          <button type="button"
                  @click="doSave"
                  :disabled="isLoading || !canSave"
                  :class="{ 'is-loading': isLoading }"
                  class="button is-success is-fullwidth">
            Save
          </button>

        </div>

        <div class="column is-one-third">
          <button type="button"
                  @click="toggle"
                  :disabled="isLoading"
                  class="button is-fullwidth">
            Cancel
          </button>
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import CarrierInfo from '@/components/CarrierInfo/CarrierInfo'
import { cloneDeep } from 'lodash-es'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CarrierInfo-Modal',

  props: {
    value: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  data() {
    return {
      isLoading: false,
      details: {},
      canSave: true
    }
  },

  components: {
    CarrierInfo
  },

  computed: {
    ...mapGetters('user', ['accountInfo'])
  },

  mounted() {
    this.details = cloneDeep(this.value)
  },

  methods: {
    ...mapActions('user', ['updateDetails']),
    async doSave() {
      try {
        this.isLoading = true
        const fullUserInfo = { ...this.accountInfo, carrier: this.details }
        await this.updateDetails(fullUserInfo)
        this.toggle()
      } catch (err) {
        console.error('Error saving account information', err)
      } finally {
        this.isLoading = false
      }
    },

    onIsComplete(isComplete) {
      this.canSave = isComplete
    },

    toggle() {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style scoped lang="scss">
.modal-card {
  width: 900px;
  max-width: 80vw;
}
</style>
